export enum FileContentType{
    Pdf,
    Jpeg,
    Png,
    Unknown = 100
}
